document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Utilities ---------- */
  function money(cents) {
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' });
  }
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Mobile nav ---------- */
  var mobileToggle = qs('#mobileNavToggle');
  var mainNav = qs('#mainNav');
  if (mobileToggle && mainNav) {
    mobileToggle.addEventListener('click', function () {
      mainNav.classList.toggle('mobile-open');
    });
    qsa('.has-dropdown > a', mainNav).forEach(function (link) {
      link.addEventListener('click', function (e) {
        if (window.innerWidth <= 767) {
          e.preventDefault();
          link.parentElement.classList.toggle('mobile-expanded');
        }
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    qsa('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    qsa('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Ajax cart ---------- */
  var cartDrawer = qs('#cartDrawer');
  var cartOverlay = qs('#cartOverlay');
  var cartLines = qs('#cartLines');
  var cartCount = qs('#cartCount');
  var cartSubtotal = qs('#cartSubtotal');

  function openCartDrawer() { if (cartDrawer) { cartDrawer.classList.add('open'); cartOverlay.classList.add('open'); } }
  function closeCartDrawer() { if (cartDrawer) { cartDrawer.classList.remove('open'); cartOverlay.classList.remove('open'); } }

  qs('#cartClose') && qs('#cartClose').addEventListener('click', closeCartDrawer);
  cartOverlay && cartOverlay.addEventListener('click', closeCartDrawer);
  ['#cartToggle', '#floatCart'].forEach(function (sel) {
    var el = qs(sel);
    if (el) el.addEventListener('click', function (e) {
      e.preventDefault();
      refreshCartDrawer();
      openCartDrawer();
    });
  });

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cartCount) cartCount.textContent = cart.item_count;
        if (!cartLines) return;
        if (cart.items.length === 0) {
          cartLines.innerHTML = '<p style="color:var(--vx-text-dim);">Your cart is empty.</p>';
        } else {
          cartLines.innerHTML = cart.items.map(function (item) {
            return '<div class="cart-line"><img src="' + (item.image || '') + '&width=100" alt=""><div><strong>' + item.product_title + '</strong><br><span class="price-new">' + money(item.final_line_price) + '</span></div></div>';
          }).join('');
        }
        if (cartSubtotal) cartSubtotal.textContent = money(cart.total_price);
      });
  }
  refreshCartDrawer();

  function addToCart(variantId, quantity, onDone) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCartDrawer();
        openCartDrawer();
        if (onDone) onDone();
      })
      .catch(function (err) { console.error('Add to cart failed', err); });
  }

  // Product card quick add buttons
  qsa('.add-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      addToCart(variantId, 1);
    });
  });

  // Main product page add-to-cart form
  var addToCartForm = qs('#AddToCartForm');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var variantId = qs('#VariantIdInput', addToCartForm).value;
      var qty = parseInt(qs('#Quantity', addToCartForm).value, 10) || 1;
      addToCart(variantId, qty);
    });
  }

  // Cart page quantity updates
  qsa('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.getAttribute('data-key');
      var qty = parseInt(input.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { window.location.reload(); });
    });
  });

  /* ---------- Variant picker (product page) ---------- */
  var productJsonEl = qs('#ProductJSON');
  if (productJsonEl) {
    var productData = JSON.parse(productJsonEl.textContent);
    var optionSelects = qsa('.variant-option-select');
    var variantIdInput = qs('#VariantIdInput');
    var priceEl = qs('#ProductPrice');
    var compareEl = qs('#ComparePrice');
    var addBtn = qs('#AddToCartBtn');

    function findVariant() {
      var selected = optionSelects.map(function (s) { return s.value; });
      return productData.variants.find(function (v) {
        return v.options.every(function (opt, i) { return opt === selected[i]; });
      });
    }
    function updateForVariant(variant) {
      if (!variant) return;
      variantIdInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (compareEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareEl.style.display = '';
          compareEl.textContent = money(variant.compare_at_price);
        } else {
          compareEl.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addBtn.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
      if (variant.featured_image) {
        var mainImg = qs('#ProductMainImage');
        if (mainImg) mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?.*)?$/i, '$1');
      }
    }
    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () { updateForVariant(findVariant()); });
    });
  }

  // Gallery thumbnail click
  qsa('.gallery-thumb-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mainImg = qs('#ProductMainImage');
      if (mainImg) mainImg.src = btn.getAttribute('data-full');
    });
  });

  /* ---------- Wishlist (localStorage) ---------- */
  var WISHLIST_KEY = 'vortex_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; } catch (e) { return []; }
  }
  function setWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    var badge = qs('#wishCount');
    if (badge) badge.textContent = list.length;
  }
  function toggleWishlist(handle, btn) {
    var list = getWishlist();
    var idx = list.indexOf(handle);
    if (idx > -1) { list.splice(idx, 1); if (btn) btn.classList.remove('is-active'); }
    else { list.push(handle); if (btn) btn.classList.add('is-active'); }
    setWishlist(list);
  }
  setWishlist(getWishlist());
  qsa('.wishlist-btn').forEach(function (btn) {
    var handle = btn.getAttribute('data-handle');
    if (handle && getWishlist().indexOf(handle) > -1) btn.classList.add('is-active');
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      toggleWishlist(handle, btn);
    });
  });
  qs('#floatWishlist') && qs('#floatWishlist').addEventListener('click', function (e) {
    if (!qs('#WishlistGrid')) return; // let the link navigate to /pages/wishlist normally
  });

  // Render wishlist grid if present on the wishlist page
  var wishlistGrid = qs('#WishlistGrid');
  if (wishlistGrid) {
    var handles = getWishlist();
    if (handles.length === 0) {
      wishlistGrid.innerHTML = '<p style="color:var(--vx-text-dim);">Your wishlist is empty. Browse products and tap the heart icon to save them here.</p>';
    } else {
      Promise.all(handles.map(function (h) { return fetch('/products/' + h + '.js').then(function (r) { return r.ok ? r.json() : null; }); }))
        .then(function (products) {
          wishlistGrid.innerHTML = products.filter(Boolean).map(function (p) {
            var img = p.featured_image ? p.featured_image : '';
            return '<div class="product-card"><a href="' + p.url + '" class="product-thumb"><img src="' + img + '&width=600" alt=""></a><div class="product-body"><h4><a href="' + p.url + '">' + p.title + '</a></h4><span class="price-new">' + money(p.price) + '</span></div></div>';
          }).join('');
        });
    }
  }

  /* ---------- Quick view ---------- */
  var quickviewModal = null;
  function closeQuickview() {
    if (quickviewModal) { quickviewModal.remove(); quickviewModal = null; }
    var overlay = qs('#quickviewOverlay');
    if (overlay) overlay.remove();
  }
  qsa('.quick-view-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var handle = btn.getAttribute('data-handle');
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        closeQuickview();
        var overlay = document.createElement('div');
        overlay.className = 'modal-overlay';
        overlay.id = 'quickviewOverlay';
        overlay.addEventListener('click', closeQuickview);
        document.body.appendChild(overlay);

        quickviewModal = document.createElement('div');
        quickviewModal.className = 'quickview-modal';
        quickviewModal.innerHTML =
          '<button type="button" class="close" aria-label="Close">&times;</button>' +
          '<div class="quickview-body">' +
          '<img src="' + (p.featured_image || '') + '&width=500" alt="">' +
          '<div class="quickview-info">' +
          '<h3>' + p.title + '</h3>' +
          '<p class="price-new" style="font-size:20px;">' + money(p.price) + '</p>' +
          '<p style="color:var(--vx-text-dim);">' + (p.description ? p.description.replace(/<[^>]*>/g, '').slice(0, 160) : '') + '</p>' +
          '<button type="button" class="btn btn-blue" id="QuickAddBtn" data-variant-id="' + p.variants[0].id + '">Add to Cart</button> ' +
          '<a href="' + p.url + '" class="btn btn-outline-blue">View Full Details</a>' +
          '</div></div>';
        document.body.appendChild(quickviewModal);
        qs('.close', quickviewModal).addEventListener('click', closeQuickview);
        qs('#QuickAddBtn', quickviewModal).addEventListener('click', function () {
          addToCart(this.getAttribute('data-variant-id'), 1, closeQuickview);
        });
      });
    });
  });

  /* ---------- Collection grid/list toggle ---------- */
  var gridBtn = qs('#gridBtn'), listBtn = qs('#listBtn');
  var gridView = qs('#catGridView'), listView = qs('#catListView');
  if (gridBtn && listBtn) {
    gridBtn.addEventListener('click', function () {
      gridBtn.classList.add('active'); listBtn.classList.remove('active');
      gridView.hidden = false; listView.hidden = true;
    });
    listBtn.addEventListener('click', function () {
      listBtn.classList.add('active'); gridBtn.classList.remove('active');
      listView.hidden = false; gridView.hidden = true;
    });
  }

  /* ---------- Countdown timers ---------- */
  qsa('.countdown').forEach(function (el) {
    var end = new Date(el.getAttribute('data-end')).getTime();
    if (isNaN(end)) return;
    function tick() {
      var dist = Math.max(0, end - Date.now());
      var d = Math.floor(dist / 86400000);
      var h = Math.floor((dist % 86400000) / 3600000);
      var m = Math.floor((dist % 3600000) / 60000);
      var s = Math.floor((dist % 60000) / 1000);
      var set = function (name, val) { var n = el.querySelector('[data-cd="' + name + '"]'); if (n) n.textContent = String(val).padStart(2, '0'); };
      set('days', d); set('hours', h); set('mins', m); set('secs', s);
    }
    tick();
    setInterval(tick, 1000);
  });

  /* ---------- Newsletter popup ---------- */
  var newsletterModal = qs('#newsletterModal');
  var newsletterOverlay = qs('#newsletterModalOverlay');
  if (newsletterModal && newsletterOverlay) {
    setTimeout(function () {
      if (!sessionStorage.getItem('vortex_newsletter_shown')) {
        newsletterModal.hidden = false;
        newsletterOverlay.hidden = false;
        sessionStorage.setItem('vortex_newsletter_shown', '1');
      }
    }, 5000);
    var closeBtn = qs('#newsletterModalClose');
    function closeNewsletter() { newsletterModal.hidden = true; newsletterOverlay.hidden = true; }
    closeBtn && closeBtn.addEventListener('click', closeNewsletter);
    newsletterOverlay.addEventListener('click', closeNewsletter);
  }

});
